/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

var confAppURL = process.env.REACT_APP_APP_URL || "https://autob2bdev.corp.al-futtaim.com"; //"https://autob2bqa.corp.al-futtaim.com";

var confADAuthDomain = process.env.REACT_APP_AD_AUTH_DOMAIN || "https://login.microsoftonline.com/79ddd250-40e1-4d41-ba0f-c9e9849725cb";
var confADClientID = process.env.REACT_APP_AD_CLIENT_ID || "e1524aa8-5bd9-4046-9ce2-616d54b29098";

var confTanentUrl = process.env.REACT_APP_BFF_TENANT_URL || "alfuttaimgroupb2cdev.onmicrosoft.com"
var confAuthDomain = process.env.REACT_APP_BFF_AUTH_DOMAIN || "alfuttaimgroupb2cdev.b2clogin.com"
var confClientID = process.env.REACT_APP_CLIENT_ID || "03e55a91-bef5-432d-bd10-82679ea8773a";   //"887445a1-6606-4fbd-90ef-70f0162ca707"; 
var confOrderLogEnabled = process.env.REACT_APP_ORDERLOG_ENABLED || 1;

// const confSFSignIn = process.env.REACT_APP_SF_SIGNIN || "B2C_1_auto_b2b_login";
const confSFSignIn = process.env.REACT_APP_SF_SIGNIN || "B2C_1_auto_b2b_signin_signup";
const confSFForgotPassword = process.env.REACT_APP_SF_FORGOT_PASS || "B2C_1_auto_b2b_password_reset";
const confSFEditProfile = process.env.REACT_APP_SF_EDIT_PROFILE || "B2C_1_auto_b2b_profile_edit";
const confSFSignUp = process.env.REACT_APP_SF_SIGNUP || "B2C_1_auto_b2b_signup";

export const QA_ENV = 'autob2bqa.corp.al-futtaim.com';
export const PRE_PROD_ENV = 'aftradepoint.corp.al-futtaim.com';
export const PRODUCTION_ENV = 'tradepoint.al-futtaimauto.com';
export const PRODUCTION_TEST_ENV = 'tradepoint.corp.al-futtaim.com';
export const ALAC_PREPROD_ENV = 'aepreprodafalac.corp.al-futtaim.com';

if (QA_ENV == window.location.hostname.toLowerCase()) {
    confAppURL = 'https://autob2bqa.corp.al-futtaim.com'
    confADClientID = 'e1524aa8-5bd9-4046-9ce2-616d54b29098'
    confTanentUrl = 'alfuttaimgroupb2cdev.onmicrosoft.com'
    confAuthDomain = 'alfuttaimgroupb2cdev.b2clogin.com'
    confClientID = '887445a1-6606-4fbd-90ef-70f0162ca707'
} else if (PRODUCTION_TEST_ENV == window.location.hostname.toLowerCase()) {
    confAppURL = "https://tradepoint.corp.al-futtaim.com";
    confADClientID = "6f70f26c-0249-4f13-bf37-5f692c4b8320";
    confTanentUrl = "alfuttaimgroupb2c.onmicrosoft.com";
    confAuthDomain = "alfuttaimgroupb2c.b2clogin.com";
    confClientID = "eb944399-b651-42a2-ac36-4ff18233ff8a";
} else if (PRE_PROD_ENV == window.location.hostname.toLowerCase()) {
    confAppURL = 'https://aftradepoint.corp.al-futtaim.com'
    confADClientID = 'b125b7d3-f621-49d2-88ab-2a4ba2e1f545'
    confTanentUrl = 'alfuttaimgroupb2cdev.onmicrosoft.com'
    confAuthDomain = 'alfuttaimgroupb2cdev.b2clogin.com'
    confClientID = '51ff610e-1c8a-4be0-b52c-2bfad5594bf6'
} else if (PRODUCTION_ENV == window.location.hostname.toLowerCase()) {
    confAppURL = 'https://tradepoint.al-futtaimauto.com'
    confADClientID = '6f70f26c-0249-4f13-bf37-5f692c4b8320'
    confTanentUrl = 'alfuttaimgroupb2c.onmicrosoft.com'
    confAuthDomain = 'alfuttaimgroupb2c.b2clogin.com'
    confClientID = 'eb944399-b651-42a2-ac36-4ff18233ff8a'
} else if (ALAC_PREPROD_ENV == window.location.hostname.toLowerCase()) {
    confAppURL = 'https://aepreprodafalac.corp.al-futtaim.com'
    confADClientID = 'b125b7d3-f621-49d2-88ab-2a4ba2e1f545'
    confTanentUrl = 'alfuttaimgroupb2cdev.onmicrosoft.com'
    confAuthDomain = 'alfuttaimgroupb2cdev.b2clogin.com'
    confClientID = '51ff610e-1c8a-4be0-b52c-2bfad5594bf6'
}


/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signIn: `${confSFSignIn}`,
        forgotPassword: `${confSFForgotPassword}`,
        editProfile: `${confSFEditProfile}`,
        signUp: `${confSFSignUp}`
    },
    authorities: {
        signIn: {
            authority: `https://${confAuthDomain}/${confTanentUrl}/${confSFSignIn}`,
        },
        forgotPassword: {
            authority: `https://${confAuthDomain}/${confTanentUrl}/${confSFForgotPassword}`, //"https://alfuttaimgroupb2cdev.b2clogin.com/alfuttaimgroupb2cdev.onmicrosoft.com/B2C_1_auto_b2b_password_reset",
        },
        editProfile: {
            authority: `https://${confAuthDomain}/${confTanentUrl}/${confSFEditProfile}`, //"https://alfuttaimgroupb2cdev.b2clogin.com/alfuttaimgroupb2cdev.onmicrosoft.com/B2C_1_auto_b2b_profile_edit"
        },
        signUp: {
            authority: `https://${confAuthDomain}/${confTanentUrl}/${confSFSignUp}` //"https://alfuttaimgroupb2cdev.b2clogin.com/alfuttaimgroupb2cdev.onmicrosoft.com/B2C_1_auto_b2b_signup"
        }
    },
    tenantUrl: `${confTanentUrl}`,
    authorityDomain: `${confAuthDomain}`
}

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {  // Need to move as constant for QA instead of turnary
    auth: {
        clientId: `${confClientID}`, //window.location.href.includes("autob2bqa.corp.al-futtaim.com") ? "887445a1-6606-4fbd-90ef-70f0162ca707" : "03e55a91-bef5-432d-bd10-82679ea8773a", // This is the ONLY mandatory field that you need to supply.
        //clientId: "9a648910-3844-4d5a-8cca-61479ca664dd", // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signIn.authority, // Use a sign-up/sign-in user-flow as a default authority
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: window.location.href.includes(`${confAppURL}`) ? `${confAppURL}/login` : `${window.location.protocol}//${window.location.hostname}${window.location.port && window.location.port !== '80' ? `:${window.location.port}` : ``}/login`, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: window.location.href.includes(`${confAppURL}`) ? `${confAppURL}/login` : `${window.location.protocol}//${window.location.hostname}${window.location.port && window.location.port !== '80' ? `:${window.location.port}` : ``}/login`, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", "profile"]
};

export const azureADConfigAdmin = {
    auth: {
        clientId: `${confADClientID}`, //"e1524aa8-5bd9-4046-9ce2-616d54b29098",
        authority: `${confADAuthDomain}`, //"https://login.microsoftonline.com/79ddd250-40e1-4d41-ba0f-c9e9849725cb",
        redirectUri: window.location.href.includes(`${confAppURL}`) ? `${confAppURL}/adminauth` : `${window.location.protocol}//${window.location.hostname}${window.location.port && window.location.port !== '80' ? `:${window.location.port}` : ``}/adminauth`
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
}

export const isOrderLogEnabled = {
    enabled: confOrderLogEnabled === 1 ? true : false,
}



